import script from "./DoctorNoticeBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorNoticeBoard.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorNoticeBoard.vue?vue&type=style&index=0&id=87dfff92&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87dfff92"]])

export default __exports__